<template>
  <b-overlay :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm">
    <div class="video"
      v-if="Object.keys(dataItem).length > 0">
      <video width="100%"
        poster="/img/poster.gif"
        :src="dataItem.low_path"
        autoplay
        controls
        type="video/*" />
      <p class="pt-1 mb-0 d-flex justify-content-center">
        <a href="javascript:void(0)"
          @click="dowload(dataItem)"
          class="btn btn-success btn-sm"
          download>Tải file gốc</a>
        <a href="javascript:void(0)"
          @click="dowload(dataItem, 'proxy')"
          class="btn btn-success btn-sm ml-1"
          download>Tải file proxy</a>
      </p>
    </div>
    <div v-else>
      <b-alert variant="primary"
        show>
        <div class="alert-body">
          <span><strong>{{ message }}</strong></span>
        </div>
      </b-alert>
    </div>
  </b-overlay>
</template>
<script>
import store from '@/store'
import { ref, watch } from '@vue/composition-api'
import { BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BAlert, BOverlay } from 'bootstrap-vue'

export default {

  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BOverlay,
    BAlert
  },
  props: {
    item: {
      type: Object,
      default: null
    },
  },
  setup(props, context) {
    const loading = ref(true)
    const dataItem = ref({})
    const message = ref('')
    if (Object.keys(props.item).length > 0) {
      let params = {
        id: props.item.id,
        uuid: props.item.uuid
      }
      store.dispatch('channel/show', params)
        .then(response => {
          loading.value = false;
          let result = response.data;
          if (result.code == 200) {
            dataItem.value = result.data;
          } else {
            message.value = result.message
          }
        })
    }

    return {
      loading,
      dataItem,
      message
    }
  },
  methods: {
    async dowload(item, type = 'orginal') {
      let url = (type == 'orginal') ? item.orginal_path : item.low_path;
      let name = (type == 'orginal') ? item.filename : 'proxy_' + item.filename
      let data = await fetch(url)
      const blob = await data.blob()
      const objectUrl = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.setAttribute('href', objectUrl)
      link.setAttribute('download', name)
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>
